/**
 * @module api-web:LabelManage
 */
import service from '@/service'

/**
 * 平均价格趋势   表查询
 * @param {{keywords:string,limit:number,page:number,sort:string}} params
 */
export function getList(data) {
  return service['api-web']({
    url: '/avgPrice/getList',
    method: 'post',
    data
  })
}

/**
 * 供应商
 * @param {{supplierName:string}} params
 */
export function getSupplierInformationPullList(params) {
  return service['api-web']({
    url: '/public/data/getSupplierInformationPullList',
    method: 'get',
    params
  })
}
